import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const BidderChangeContactDialogTourConfig: AgTechTourConfig = {
    id: 'bidder-change-contact-dialog-tour',
    name: 'Change Contact Tour',
    steps: [
        {
            targetId: 'bidder-change-contact',
            title: 'New Contact',
            description: 'Pick the contact this bidder number should belong to. Contacts already registered as another bidder in this sale are not offered.',
            position: 'bottom',
        },
    ]
}
